import { render } from "./MoneyField.vue?vue&type=template&id=00cefb08"
import script from "./MoneyField.vue?vue&type=script&lang=js"
export * from "./MoneyField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__